import numeral from 'numeral';

export default (size, message) => {
  const messageSize = numeral(size).format('0b');
  const myMessage = message || `File size must be less than ${messageSize}`;

  return value => ({
    isValid: (value instanceof Array || value instanceof Object) && value[0] instanceof File && value[0].size <= size,
    message: myMessage,
  });
};



// WEBPACK FOOTER //
// ./src/common/utils/fileSizeLessThan.js